import React, { useState, useEffect } from "react"
import dateFormat from 'dateformat';

import { Form, Row } from "react-bootstrap"

import InputField from '../elements/input'
import SelectField from '../elements/select'
import TextAreaField from '../elements/textarea'
import CheckboxField from '../elements/checkbox'
import RadioboxField from '../elements/radio'
import ButtonField from '../elements/button'
import HtmlBox from '../elements/html'
import ReCaptchaBox from '../elements/recaptcha'
import '../assets/styles/_index.scss'
import { phoneNumberValidation, getUrlParams } from "../../../common/utils/site_utlis"
import { getUser } from "@starberry/myaccount-website-utils"


function Rent_Home_5(props) {
  const userData = getUser();

  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showerrormsg, setShowerrorMsg] = useState("");
  const [showthankyou, setThankyou] = useState(false);
  const [startDate, setStartDate] = useState();
  const [startTime, setStartTime] = useState();

  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectError, setSelectError] = useState(false);

  const myRef = React.createRef();

  const [show_adverse_credit, setAdverseCredit] = useState(false);
  const [show_living_option, setLivingOption] = useState(false);
  const [show_guarantor, setGuarantor] = useState(false);

  //console.log("location ==>", location, replace_slashes, props.title);


  var fields = ([
    {
        error_text: "Highlighted fields are required.",
        success_text: "Thank you, a member of our team will be in contact soon.",
    },
    {
        text: '<b>Applicant 4: Details</b>',
        element: "html",
        class: "mt-2 content_r-m mb-3 heading_text"
    },
    {
        grpmd: "12",
        label: "First Name",
        placeholder: "",
        name: "first_name_applicant_4",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[a-zA-Z0-9._-]+(\\s+[a-zA-Z0-9._-]+)*$",
        labelClass: "annual-txt",
        errorMsg: "Alphanumeric and special characters (-_.) are only allowed.",
        divclass: "form-wrap",
        defaultValue: userData?.name || ``
    }, 
    {
        grpmd: "12",
        label: "Last Name",
        placeholder: "",
        name: "last_name_applicant_4",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[a-zA-Z0-9._-]+(\\s+[a-zA-Z0-9._-]+)*$",
        labelClass: "annual-txt",
        errorMsg: "Alphanumeric and special characters (-_.) are only allowed.",
        divclass: "form-wrap",
        defaultValue: userData?.surname || ``
    },
    {
        grpmd: "12",
        label: "Applicant 4: Date of Birth",
        placeholder: "",
        name: "dob_applicant_4",
        type: "date",
        element: "input",
        required: true,
        // patternchk:"^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
        labelClass: "annual-txt",
        class:"date_field form-control",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Email Address",
        placeholder: "",
        name: "email_applicant_4",
        type: "email",
        element: "input",
        required: true,
        patternchk:"[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
        labelClass: "annual-txt",
        errorMsg: "Enter a valid email id, Ex: james123@gmail.com, JAMES123@GMAIL.COM.",
        divclass: "form-wrap",
        defaultValue: userData?.email || ``
    },
    {
        grpmd: "12",
        label: "Applicant 4: Phone Number",
        placeholder: "",
        name: "telephone_applicant_4",
        type: "text",
        element: "input",
        required: true,
        patternchk:"^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
        labelClass: "annual-txt",
        errorMsg: "Enter a valid phone number, Ex: 01234 567 890.",
        divclass: "form-wrap",
        defaultValue: userData?.mobile || ``
    },
    {
        grpmd: "12",
        label: "Applicant 4: Do you smoke?",
        placeholder: "",
        name: "smoke_applicant_4",
        element: "radio",
        required: true,
        selected:"",
        values: ['Yes', 'No'],
        labelClass: "annual-txt",
        class: "",
        divclass: "radio_wrap form-wrap"
    }, 
    {
        grpmd: "12",
        label: "Applicant 4: Have you had any CCJs, adverse credit or been declared bankrupt in the last 6 years?",
        placeholder: "",
        name: "adverse_credit_applicant_4",
        element: "radio",
        required: true,
        selected:"",
        values: ['Yes', 'No', 'Unsure'],
        labelClass: "annual-txt",
        class: "",
        divclass: "radio_wrap form-wrap"
    }]
  )
  
  fields.push(
    {
        grpmd: "12",
        label: "Applicant 4: Enter details here",
        placeholder: "",
        name: "adverse_credit_input_applicant_4",
        element: "textarea",
        class: "",
        required: show_adverse_credit,
        rows: "4",
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_adverse_credit ? "" : "d-none"}`
    }
  )

  
  fields.push(
    {
        text: '<b>Applicant 4: Your Current Accomodation</b>',
        element: "html",
        class: "mt-2 content_r-m mb-3 heading_text"
    },
    {
        grpmd: "12",
        label: "Applicant 4: What is your current registered address?",
        placeholder: "",
        name: "current_address_applicant_4",
        type: "text",
        element: "input",
        required: true,
        labelClass: "annual-txt",
        divclass: "form-wrap"
    }, 
    {
        grpmd: "12",
        label: "Applicant 4: Select which applies to you:",
        placeholder: "",
        name: "living_option_applicant_4",
        element: "radio",
        required: true,
        selected:"",
        values: ['Currently Renting', 'Homeowner', 'Living with friends / relatives', 'Other'],
        labelClass: "annual-txt",
        class: "",
        divclass: "radio_wrap form-wrap full_wdth_check"
        
    }
  )
  
  fields.push(
    {
        grpmd: "12",
        label: "Applicant 4: Please enter your living situation:",
        placeholder: "",
        name: "living_option_input_applicant_4",
        type: "text",
        element: "input",
        required: show_living_option,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_living_option ? "" : "d-none"}`

    }
  )

  fields.push(
    {
        grpmd: "12",
        label: "Applicant 4: Length of time at current property",
        placeholder: "",
        name: "length_of_time_property_applicant_4",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: End Date (Approx)",
        placeholder: "",
        name: "end_date_applicant_4",
        type: "valuation_date",
        element: "input",
        required: false,
        // patternchk:"^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
        labelClass: "annual-txt",
        class:"date_field form-control",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Current rent amount (if applicable) (£)",
        placeholder: "",
        name: "current_rent_amount_applicant_4",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Current landlord/letting agent name (if applicable)",
        placeholder: "",
        name: "landlord_name_applicant_4",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Why are you looking to move?",
        placeholder: "",
        name: "why_move_applicant_4",
        type: "text",
        element: "textarea",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap",
        class: "",
        rows: "4"
    },
    {
        text: '<b>Applicant 4: Your Current Employment</b>',
        element: "html",
        class: "mt-2 content_r-m mb-3 heading_text"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Please select your employment status (if applicable)",
        placeholder: "",
        name: "employment_status_applicant_4",
        element: "radio",
        required: true,
        selected:"",
        values: ['Full Time (Permanent)', 'Full Time (Temp/Probation)', 'Self Employed', 'Student', 'Unemployed', 'Retired'],
        labelClass: "annual-txt",
        class: "",
        divclass: "radio_wrap form-wrap full_wdth_check"
    }, 
    {
        text: '<b>Note:</b> If you are self-employed, you must be able to provide your tax return for the most recent fiscal year, or an accountants reference.',
        element: "html",
        class: "mt-0 content_r-m mb-3"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Occupation (if applicable)",
        placeholder: "",
        name: "occupation_applicant_4",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Employer name (if applicable)",
        placeholder: "",
        name: "employer_name_applicant_4",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Income (£)",
        placeholder: "",
        name: "employer_income_applicant_4",
        type: "text",
        element: "input",
        required: true,
        labelClass: "annual-txt",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Annual Bonuses/Commission (if applicable) (£)",
        placeholder: "",
        name: "annual_bonuses_applicant_4",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: Employment Start Date (if applicable)",
        placeholder: "",
        name: "emp_start_date_applicant_4",
        type: "date",
        element: "input",
        required: false,
        // patternchk:"^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
        labelClass: "annual-txt",
        class:"date_field form-control",
        divclass: "form-wrap"
    },
    {
        grpmd: "12",
        label: "Applicant 4: If required, are you able to provide a guarantor?",
        placeholder: "",
        name: "provide_guarantor_applicant_4",
        element: "radio",
        required: false,
        selected:"",
        values: ['I have a suitable guarantor', 'I am able to pay 6 month\'s rent in advance', 'I have a suitable guarantor and am also able to pay 6 month\'s rent in advance', 'No - I do not have a guarantor and am unable to pay 6 month\'s rent in advance'],
        labelClass: "annual-txt",
        class: "",
        divclass: "radio_wrap form-wrap full_wdth_check"
    },
    {
        text: 'Most landlords require a guarantor, who must a be permanent UK resident, in full time employment, self employed or retired with a suitable pension. Your guarantor will need to have an annual income of 3 times the annual rent. Please provide details of an individual who will act as your guarantor for the tenancy. Guarantors will be required to provide satisfactory references and enter into a Guarantor Agreement, for the duration of the tenancy, including any extension to the initial term.',
        element: "html",
        class: "mt-0 content_r-m mb-3"
    }, 
  )


  fields.push(
    {
        grpmd: "12",
        label: "Guarantor Name",
        placeholder: "",
        name: "guarantor_name_applicant_4",
        type: "text",
        element: "input",
        required: show_guarantor,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_guarantor ? "" : "d-none"}`
    },
    {
        grpmd: "12",
        label: "Guarantor Mobile Number",
        placeholder: "",
        name: "guarantor_phone_number_applicant_4",
        type: "text",
        element: "input",
        required: show_guarantor,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_guarantor ? "" : "d-none"}`
    },
    {
        grpmd: "12",
        label: "Guarantor Email Address",
        placeholder: "",
        name: "guarantor_email_applicant_4",
        type: "text",
        element: "input",
        required: show_guarantor,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_guarantor ? "" : "d-none"}`
    },
    {
        grpmd: "12",
        label: "Guarantor Address",
        placeholder: "",
        name: "guarantor_address_applicant_4",
        type: "text",
        element: "input",
        required: show_guarantor,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_guarantor ? "" : "d-none"}`
    },
    {
        grpmd: "12",
        label: "Guarantor Employer",
        placeholder: "",
        name: "guarantor_employer_applicant_4",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_guarantor ? "" : "d-none"}`
    },
    {
        grpmd: "12",
        label: "Guarantor Job Title",
        placeholder: "",
        name: "guarantor_job_title_applicant_4",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_guarantor ? "" : "d-none"}`
    },
    {
        grpmd: "12",
        label: "Guarantor Annual Income (If known) (£)",
        placeholder: "",
        name: "guarantor_income_applicant_2",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_guarantor ? "" : "d-none"}`
    }
  )

  fields.push(
    {
        grpmd: "6",
        name: "previous",
        type: "button",
        element: "button",
        value: "Previous",
        class: "btn btn-green",
        labelClass: "",
        customClass: "custom-button-wrapper mt-4 col-md-6",
        divclass: "form-wrap"
    },

    {
        grpmd: "6",
        name: "SUBMIT",
        type: "submit",
        element: "button",
        value: "Next",
        class: "btn btn-green",
        labelClass: "",
        customClass: "custom-button-wrapper mt-4 col-md-6",
        divclass: "form-wrap"
    }
  )


  const handlechange = event => {
    // remove initial empty spaces

    if(event.target.name === "adverse_credit_applicant_4"){
      if(event.target.value === "Yes"){
          setAdverseCredit(true)
      } else{
          setAdverseCredit(false)
      }
    } 

    if(event.target.name === "living_option_applicant_4"){
      if(event.target.value === "Other"){
          setLivingOption(true)
      } else{
          setLivingOption(false)
      }
    } 

    if(event.target.name === "provide_guarantor_applicant_4"){
      if(event.target.value === "I have a suitable guarantor"){
          setGuarantor(true)
      } else{
          setGuarantor(false)
      }
    } 

    if (event.type === "select") {
      //event.value = event.value.trimStart()

      setSelectedOptions(event);
    } else {
      if (event.target.name === "telephone") {
        var valid_phone = phoneNumberValidation(event.target.value);
        if (valid_phone) {
          event.target.value = valid_phone;
        } else {
          event.target.value = '';
        }
      } else {
        event.target.value = event.target.value.trimStart()
      }
    }

  }


  const handleSubmit = event => {

    const form = event.currentTarget;

    //console.log("event =>", form);

    var form_obj_arr = Object.entries(form);

    //console.log("form_obj_arr =>", form_obj_arr.filter(item => item[1].required === true));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      setShowerrorMsg(fields[0].error_text)

      if (selectedOptions?.value) {
        setSelectError(false);
      } else {
        setSelectError(true);
      }

      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    else {

      event.preventDefault();
      const formsdata = (event.target);

      const json = {}
      Object.keys(formsdata).map(key => {

        if (formsdata[key].type === "checkbox") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = 'yes'
          }
        } else if (formsdata[key].type === "radio") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = formsdata[key].value
          }
        } else {
          json[formsdata[key].name] = formsdata[key].value
        }

      })

      var params = getUrlParams();

      json['adverse_credit_applicant_4'] = show_adverse_credit ? json.adverse_credit_input_applicant_4 : json.adverse_credit_applicant_4;
      json['living_option_applicant_4'] = show_living_option ? json.living_option_input_applicant_4 : json.living_option_applicant_4;

      //console.log("formsdata_json", json);

      //console.log("formdata step5", json);

      props.setFormvaluesFunc(json);

      props.setStep("final");

      props.setPrevStep("step5")

      setValidated(false);
      setShowerror(false);
      // setSelectError(false);
      // setSelectedOptions({});

      // // reset form
      // const form = event.target
      // form.reset();
      // setStartDate();
      // setStartTime();

    }
  };

  const handleBack = () => {
    props.setStep("step4");
    window.scrollTo(0,0)
  }

  //console.log("selectedOptions", selectedOptions);

  return (
    <div className="form rent_form">

      {showerror && <div className="alert alert-danger">
        {showerrormsg}
      </div>}
      <div ref={myRef}></div>

      {showthankyou && <div className="alert alert-success">
        {fields[0].success_text}
      </div>}


      <Form name={fields[0].formname} id="step_5" className={props.classNames} action="/" method="post" noValidate validated={validated} onSubmit={handleSubmit} autoComplete="off">

        <input type="hidden" name="applicant_4_display" value={"block"} />

        <Row className="custom-text-field-wrapper no_direction">
          {fields.map((field, index) => {
            if ("input" === field.element) {
              return (
                <InputField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={handlechange}
                  errorMsg={field.errorMsg}
                  startDate={field.type === 'valuation_date' ? startDate : ''}
                  setStartDate={field.type === 'valuation_date' ? setStartDate : ''}
                  startTime={field.type === 'valuation_time' ? startTime : ''}
                  setStartTime={field.type === 'valuation_time' ? setStartTime : ''}
                  defaultValue={field?.defaultValue}
                />
              );
            }
            if ("select" === field.element) {
              return (
                <SelectField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  required={field.required}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  values={field.values}
                  key={`${field.element}~${index}`}
                  handlechange={handlechange}
                  componentprops={props}
                  //selectedValue={selectedOptions}
                  errorMsg={field.errorMsg}
                  isError={selectError}
                //isError= {Object.keys(selectError).length > 0 ? (selectError[field.name] ? '' : true) : ''}
                  optionWithLabel={true}
                />
              );
            }
            if ("textarea" === field.element) {
              return (
                <>

                  <TextAreaField
                    name={field.name}
                    divclass={field.divclass}
                    grpmd={field.grpmd}
                    label={field.label}
                    ref={field.ref}
                    rows={field.rows}
                    fieldClass={field.class}
                    labelClass={field.labelClass}
                    placeholder={field.placeholder}
                    required={field.required}
                    key={`${field.element}~${index}`}
                    handlechange={handlechange}
                    errorMsg={field.errorMsg}
                  />
                </>
              );
            }
            if ("checkbox" === field.element) {
              return (
                <CheckboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                />
              );
            }
            if ("radio" === field.element) {
              return (
                <RadioboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  values={field.values}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                  label={field.label}
                />
              );
            }
            if ("html" === field.element) {
              return (
                <HtmlBox
                  text={field.text}
                  fieldClass={field.class}
                  key={`${field.element}~${index}`}
                />
              );
            }
            // if ("captcha" === field.element) {
            //   return (
            //     <ReCaptchaBox
            //       fieldClass={field.class}
            //       captRef={field.captchaRef}
            //       key={`${field.element}~${index}`}
            //       handleonVerify={handleonVerify}
            //     />
            //   );
            // }
            if ("button" === field.element) {
              return (
                <>

                  <ButtonField
                    name={field.name}
                    fieldClass={field.class}
                    type={field.type}
                    value={field.value}
                    key={`${field.element}~${index}`}
                    grpmd={field.grpmd}
                    customClass={field.customClass}
                    handlClick={handleBack}
                  />

                </>
              );
            }
          })
          }
        </Row>
      </Form>

    </div>
  );
}


const RentHomeStep5 = (props) => (
  <Rent_Home_5 {...props} />

)

export default RentHomeStep5